import bus from './bus.js';
import Editor from './Editor.vue';
import locale from './locales/russian.js';


export default {
    install: (Vue, userOptions = {}) => {
        if (userOptions.locale) {
            if (typeof userOptions.locale == 'string') {
                userOptions.locale = locale;
            }
        }
        bus.options = { ...bus.options, ...userOptions };
        Vue.component('wysiwyg', Editor);
    },
    component: Editor,
};
